import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@/components/common/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  text-align: center;
  padding: ${({ theme }) => theme.spacing['2xl']};
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes['4xl']};
  color: ${({ theme }) => theme.colors.onBackground};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Message = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.muted};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>404</Title>
      <Message>Page not found</Message>
      <Button onClick={() => navigate('/')}>Return to Home</Button>
    </Container>
  );
};
